import React from 'react';

const Sorting = ({ resourcedTexts, sortOptions, onSorting, sortOrder }) => {
    if (!sortOptions.length) {
        return null;
    }

    return (
        <div className="sort-filter">
            <label htmlFor="sort">{resourcedTexts.searchSortingText}</label>

            <div className="form-field sort-filter__form-field">
                <select name="sort" id="sort" onChange={(e) => onSorting(e.target.value)} value={sortOrder}>
                    {sortOptions.map(({ value, name }) => (
                        <option key={value} value={value}>
                            {name}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export { Sorting };
